export interface LegacyRedirect {
    from: string;
    to: string | ((params: Record<string, string | undefined>) => string);
}

export const LEGACY_REDIRECTS: LegacyRedirect[] = [
    { from: '/practices', to: '/grow/practices' },
    { from: '/practice/:id', to: (p) => `/grow/practices/${p.id}` },
    { from: '/knowledge-library', to: '/grow/knowledge-library' },
    { from: '/practice-management-groups', to: '/grow/practice-management-groups' },
    { from: '/practice-management-pmg/:id', to: (p) => `/grow/practice-management-pmg/${p.id}` },
    { from: '/admin-my-groups', to: '/grow/my-groups' },
    { from: '/ipoc', to: '/grow/ipoc' },
    { from: '/cpoc/:id', to: (p) => `/grow/cpoc/${p.id}` },
    { from: '/practice-valuation-reports', to: '/grow/practice-valuation-reports' },
    { from: '/practice-brokerage-services', to: '/connect/practice-brokerage-services' },
    { from: '/practice-brokerage-services/:isComingSoon', to: (p) => `/connect/practice-brokerage-services/${p.isComingSoon}` },
    { from: '/data-request-dashboard', to: '/grow/data-request-dashboard' },
    { from: '/data-request-dashboard/others', to: '/grow/data-request-dashboard/others' },
    { from: '/standardization-sevices', to: '/standardization-services' },

    { from: '/my-referrals', to: '/share/my-referrals' },
    { from: '/withdraw', to: '/share/withdraw' },
    { from: '/charities', to: '/share/charities' },
    { from: '/charities/:id/edit', to: (p) => `/share/charities/${p.id}/edit` },
    { from: '/charities/:id/withdraw', to: (p) => `/share/charities/${p.id}/withdraw` },
    { from: '/donate', to: '/share/donate' },
    { from: '/nonprofits', to: '/share/nonprofits' },
    { from: '/charityapproval', to: '/charity-approval' },
    { from: '/practicerequests', to: '/share/practice-requests' },
    { from: '/referralrequests', to: '/share/referral-requests' },
    { from: '/marketplace/engagement/:engagementId', to: (p) => `/connect/engagement/${p.engagementId}` },
    { from: '/marketplace/meetings', to: '/connect/meetings' },
    { from: '/engagement/:engagementId', to: (p) => `/connect/engagement/${p.engagementId}` },
    { from: '/opportunities', to: '/connect/opportunities' },
];
